// extracted by mini-css-extract-plugin
export var backdropBlur = "_eb-0";
export var contentCard = "_eb-5";
export var frame = "_eb-2";
export var image = "_eb-4";
export var imagePane = "_eb-3";
export var modal = "_eb-1";